import { Plus } from 'lucide-react';
import { Frame } from '@/marketing/Frame';
import { Stagger, StaggerItem } from '@/lib/motion';

const FAQS = [
  {
    q: 'Is the ETF live yet?',
    a: 'Not yet. This site represents the planned NovaQuantis ETF and strategy. Launch timing and availability will be communicated through official channels.',
  },
  {
    q: 'What will I own?',
    a: 'Shares of a single ETF that holds an AI-managed portfolio of 20–30 names — bought and sold like any other stock in your brokerage account.',
  },
  {
    q: 'Is performance guaranteed?',
    a: 'No. All investing involves risk, including possible loss of principal. Nothing here is a guarantee, a prediction of returns, or investment advice.',
  },
  {
    q: 'Do I need to be accredited?',
    a: 'No — that is the point. An ETF is open to any investor, subject to the normal rules of the exchange and your broker.',
  },
];

export function Faq() {
  return (
    <Frame id="faq" label="Questions">
      <Stagger className="mx-auto max-w-3xl">
        {FAQS.map((item) => (
          <StaggerItem key={item.q}>
            <details className="group border-t border-white/8 py-6 [&_summary]:list-none">
              <summary className="flex cursor-pointer items-start justify-between gap-6">
                <span className="font-display text-lg font-medium text-foreground">
                  {item.q}
                </span>
                <Plus className="mt-1 size-4 shrink-0 text-[color:var(--nq-blue-bright)] transition-transform duration-300 group-open:rotate-45" />
              </summary>
              <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted-foreground">
                {item.a}
              </p>
            </details>
          </StaggerItem>
        ))}
      </Stagger>
    </Frame>
  );
}
